import { render, staticRenderFns } from "./storageRecordModal.vue?vue&type=template&id=beb544da&"
import script from "./storageRecordModal.vue?vue&type=script&lang=js&"
export * from "./storageRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports